import(/* webpackMode: "eager" */ "/usr/src/app/apps/portal-frontend/src/app/error.tsx");
